import React from 'react';
import {
  TextInput,
  SingleCheckbox,
  Row,
  Col,
  ButtonIcon
} from '@youngcapital/component-library';

import classNames from 'classnames';
import { FIELDSET_PROPTYPES } from '../asFieldset';
import ResponsiveDatePicker from '../../ResponsiveDatePicker';

const WorkExperience = ({
  index,
  getFieldProps,
  t,
  removeWorkExperience,
  isOnlyField
}) => {
  const getKey = prop => `work_experiences[${index}].${prop}`;
  const isCurrentJob = getFieldProps(getKey('is_current')).value;
  const dateEnd = getFieldProps(getKey('date_end'));

  return (
    <>
      <hr className={classNames(isOnlyField ? 'mb-2' : 'mb-0')} />
      {!isOnlyField && (
        <Row>
          <Col xs={12}>
            <div className='end-xs'>
              <ButtonIcon
                iconVariant='close-cross'
                onClick={removeWorkExperience}
                id={`${index}`}
                title='remove-work-experience-button'
              />
            </div>
          </Col>
        </Row>
      )}
      <TextInput
        {...getFieldProps(getKey('company'))}
        type='text'
        label={t('cv_fieldset.work_experiences.company_label')}
        isRequired
      />
      <TextInput
        {...getFieldProps(getKey('function_title'))}
        type='text'
        label={t('cv_fieldset.work_experiences.function_title_label')}
        isRequired
      />
      <TextInput
        {...getFieldProps(getKey('city'))}
        type='text'
        label={t('cv_fieldset.work_experiences.city_label')}
        isRequired
      />
      <ResponsiveDatePicker
        fieldProps={getFieldProps(getKey('date_start'))}
        label={t('cv_fieldset.work_experiences.date_start_label')}
        noDays
      />
      {!isCurrentJob && (
        <ResponsiveDatePicker
          fieldProps={getFieldProps(getKey('date_end'))}
          label={t('cv_fieldset.work_experiences.date_end_label')}
          noDays
        />
      )}
      <div className='mt-2x'>
        <SingleCheckbox
          label={t('cv_fieldset.work_experiences.is_current_label')}
          {...getFieldProps(getKey('is_current'), ({ value, ...props }) => ({
            ...props,
            checked: value,
            onBlur: (_, e) => props.onBlur(e),
            onChange: (_, e) => {
              dateEnd.setValue('');
              props.onChange(e);
            }
          }))}
        />
      </div>
      <div className='mt-2x'>
        <SingleCheckbox
          label={t('cv_fieldset.work_experiences.is_agency_label')}
          {...getFieldProps(getKey('is_agency'), ({ value, ...props }) => ({
            ...props,
            checked: value,
            onBlur: (_, e) => props.onBlur(e),
            onChange: (_, e) => props.onChange(e)
          }))}
        />
      </div>
    </>
  );
};

WorkExperience.propTypes = FIELDSET_PROPTYPES;

export default WorkExperience;
